module.exports = __webpack_public_path__ + "static/client17-a47e93be48b17f8ea1f33c05d0961c53.png";